import qs from 'qs';
import {LngLat} from 'mapbox-gl';
import {defaultPrintProps} from '../../components/map2/sidebars/PrintSidebar';

export interface UrlProps {
    layers?: string[];
    center?: mapboxgl.LngLat;
    zoom?: number;
    highlight?: MapHighlight;
    sidebar?: MapSidebar;
    popup?: MapPopup;
}

// eslint-disable-next-line complexity
export function stringifyUrlProps({
    sidebar,
    layers,
    zoom,
    center,
    highlight,
    popup
}: UrlProps): string {

    return '?' + qs.stringify({
        ...qs.parse(location.search.slice(1)),

        loc: zoom && center ?
            zoom.toFixed(1) + '/' + center.lng.toFixed(4) + '/' + center.lat.toFixed(4) :
            undefined,

        layer: layers && layers.length ?
            layers.slice(0).reverse() :
            undefined,

        sidebar: sidebar && sidebar.type === 'print' ?
            'print' :
            undefined,

        osmId: popup && popup.type === 'osm' ?
            popup.osmId :
            undefined,

        osmLoc: popup && popup.type === 'osm' ?
            `${popup.lngLat.lng.toFixed(5)}/${popup.lngLat.lat.toFixed(5)}` :
            undefined,

        osmTitle: popup && popup.type === 'osm' ?
            popup.title :
            undefined,

        pubLink: highlight && highlight.type !== 'geometry' ?
            highlight.pubLink :
            undefined,

        trackId: highlight && highlight.type === 'track' ?
            highlight.id :
            undefined,

        areaId: highlight && highlight.type === 'area' ?
            highlight.id :
            undefined,

        waypointId: highlight && highlight.type === 'waypoint' ?
            highlight.id :
            undefined,

        folderId: highlight && highlight.type === 'folder' ?
            highlight.id :
            undefined,
    }, {arrayFormat: 'comma', encode: false});
}


export function parseUrlProps(inputString: string): UrlProps {

    const input: any = qs.parse(inputString.slice(1));
    const output: Partial<UrlProps> = {};

    if (input.loc) {
        const parts = input.loc.split('/');
        output.center = new LngLat(Number(parts[1]), Number(parts[2]));
        output.zoom = Number(parts[0]);

    } else if (input.lon && input.lat) {
        output.center = new LngLat(Number(input.lon), Number(input.lat));
        output.zoom = Number(input.zoom);
    }

    if (input.waypointId) {
        output.highlight = {
            type: 'waypoint',
            id: input.waypointId,
            pubLink: input.pubLink,
        };
    } else if (input.folderId) {
        output.highlight = {
            type: 'folder',
            id: input.folderId,
            pubLink: input.pubLink,
        };
    } else if (input.trackId) {
        output.highlight = {
            type: 'track',
            id: input.trackId,
            pubLink: input.pubLink,
        };
    } else if (input.areaId) {
        output.highlight = {
            type: 'area',
            id: input.areaId,
            pubLink: input.pubLink,
        };
    }

    if (input.sidebar === 'print') {
        output.sidebar = defaultPrintProps;
    }

    if (input.sidebar === 'layers') {
        output.sidebar = {type: 'layers'};
    }

    if (input.layer) {
        output.layers = input.layer.split(',').reverse();
    }

    const osmId = Number(input.osmId);
    const [osmLng, osmLat] = (input.osmLoc ? input.osmLoc.split('/') : []).map(Number);
    if (!isNaN(osmId) && !isNaN(osmLng) && !isNaN(osmLat)) {
        output.popup = {
            type: 'osm',
            lngLat: new LngLat(osmLng, osmLat),
            osmId,
            title: input.osmTitle,
            mapboxLayerId: undefined,
        };
    }

    return output;
}
